import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=589b8971&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=589b8971&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b8971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589b8971')) {
      api.createRecord('589b8971', component.options)
    } else {
      api.reload('589b8971', component.options)
    }
    module.hot.accept("./BaseChart.vue?vue&type=template&id=589b8971&scoped=true", function () {
      api.rerender('589b8971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echartZyz/components/BaseChart.vue"
export default component.exports